import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { FieldBox } from '../../../field-box/FieldBox.mjs';
import { useFormFieldContext } from '../../context.mjs';

const FormFieldFieldBox = forwardRef(
  ({ disabled: disabledFromProps, state: stateFromProps, ...props }, forwardedRef) => {
    const { disabled: disabledFromContext, state: stateFromContext } = useFormFieldContext("FormField.FieldBox");
    return /* @__PURE__ */ jsx(
      FieldBox,
      {
        "data-scope": "form-field",
        "data-part": "field-box",
        disabled: disabledFromProps ?? disabledFromContext,
        state: stateFromProps ?? stateFromContext,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
FormFieldFieldBox.displayName = "FormField.FieldBox";

export { FormFieldFieldBox };
//# sourceMappingURL=FieldBox.mjs.map
